import "./assets/style/main.scss";
import Footer from "./components/Footer";
import GunMan from "./components/GunMan";
import Hero from "./components/Hero";
// import Offering from "./components/Offering";
import OnePromise from "./components/OnePromise";
// import Plan from "./components/Plan";
import SampleVideo from "./components/SampleVideo";
import WhatWeDo from "./components/WhatWeDo";
import React, { useEffect } from "react";
import Lenis from "lenis";
// import { Canvas } from "@react-three/fiber";
// import { PresentationControls, Stage, Environment } from "@react-three/drei";
import ZoomImages from "./components/ZoomImages";
import WhatWeDonew from "./components/WhatWeDoNew";
// import Model from "./components/ModelObj";
// import CalPreview from "./components/CallPreview";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Slider from "./components/Slider";
// import Pillars from "./components/Pillars";
import Header from "./components/Header";
import Leadership from "./components/Leadership";


function App() {
  useEffect(() => {
    const lenis = new Lenis();
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }, []);

  return (
    <Router>

      <Header />

      <Routes>
        <Route path="/slider" element={<Slider />} />

        <Route
          path="/"
          element={
            <div className="main-content-wrapper">

              <Hero />
              <OnePromise />
              <WhatWeDonew />
              <ZoomImages />
              <WhatWeDo />
              <SampleVideo />
              <Leadership />
              <GunMan />

              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;